import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { ValidationMessage_default } from "./chunk-ZQDBVQVV.js";
import { Icon_default } from "./chunk-HALE5GZ6.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Listbox/Listbox.Option.tsx
import clsx from "clsx";
import { ListboxOption as HeadlessListboxOption } from "@headlessui/react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var LISTBOX_OPTION_CLASSNAME_MAP = {};
var ListboxOption = _a => {
  var _b = _a,
    {
      children,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["children", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */jsx(HeadlessListboxOption, __spreadProps(__spreadValues({
    className: clsx("pd:listbox-option", className)
  }, rest), {
    children: _ref => {
      let {
        selected
      } = _ref;
      return /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsxs("div", {
          className: "pd:flex pd:items-center pd:gap-1",
          children: [selected && /* @__PURE__ */jsx(Icon_default, {
            icon: "check",
            className: "pd:text-primary-500"
          }), children]
        }), validation && /* @__PURE__ */jsxs("div", {
          className: "pd:flex pd:items-center pd:gap-[0.5em] pd:text-sm",
          children: [/* @__PURE__ */jsx(ValidationIcon_default, {
            variant: validation,
            className: "pd:size-5"
          }), /* @__PURE__ */jsx(ValidationMessage_default, {
            as: "span",
            variant: validation,
            className: "pd:list-box-option__validation-message",
            children: validationMessage
          })]
        })]
      });
    }
  }));
};
var Listbox_Option_default = ListboxOption;
export { LISTBOX_OPTION_CLASSNAME_MAP, Listbox_Option_default };